// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentWizardType = function (x) {
    return x;
};
var tsBridgeDocumentWizardTyp = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentWizardType")("__brandDocumentWizardType"));
    }
};
var writeDocumentWizardType = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentWizardType = Data_Show.showString;
var readDocumentWizardType = Simple_JSON.readString;
var ordDocumentWizardType = Data_Ord.ordString;
var newtypeDocumentWizardType = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentWizardType = DocumentWizardType;
var hasRuntimeTypeDocumentWizardType = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentWizardType = Data_Eq.eqString;
export {
    DocumentWizardType,
    makeDocumentWizardType,
    unwrap,
    newtypeDocumentWizardType,
    eqDocumentWizardType,
    ordDocumentWizardType,
    showDocumentWizardType,
    readDocumentWizardType,
    writeDocumentWizardType,
    hasRuntimeTypeDocumentWizardType,
    tsBridgeDocumentWizardTyp
};
//# sourceMappingURL=index.js.map
